module.exports = __webpack_public_path__ + "img/entrega.27669193.png";